module.exports = __webpack_public_path__ + "img/icon_orders_mobile.e6e87d8c.svg";